import './style.scss'

import { mapGetters } from 'vuex'
import verifyLeadingSlashLang from 'util/verifyLeadingSlashLang'

export default {
  name: 'MainNav',
  computed: {
    ...mapGetters(['getMenu', 'loaded', 'lang']),
    menu () {
      return this.getMenu('main')
    }
  },
  render (h) {
    const { loaded, menu, lang } = this
    return (
      <nav class='MainNav'>
        {loaded
          ? <ul class='MainNav__list'>
            {menu && menu.items ? (menu.items.map(i => (
              <li class='MainNav__list-item'>
                { /* TODO: Get full path (all/them/slugs) */ }
                <router-link to={verifyLeadingSlashLang(i.object_slug, lang)} class={'MainNav__list-item-link'}>
                  {i.title}
                </router-link>

                { i.children && i.children.length
                  ? (<ul class='MainNav__sublist'>
                  {i.children.map(c => (
                    <li class='MainNav__sublist-item'>
                      { /* TODO: Get full path from children, maybe it's better not to assume they're directly nested */ }
                      <router-link to={verifyLeadingSlashLang(`${i.object_slug}/${c.object_slug}`, lang)} class={'MainNav__sublist-item-link'}>
                        {c.title}
                      </router-link>
                    </li>
                ))}
                </ul>)
                : null
                }
              </li>
            ))) : null}
          </ul>
        : 'Loading…' }
      </nav>
    )
  }
}



// WEBPACK FOOTER //
// ./client/components/MainNav/index.js